export const APP_URL = {

    user: {
        homepage: '/home/get-your-online-quote',
        youWillNeed: '/home/you-will-need',
        logout: '/home/logout',
    },
    quote: {
        yourSavedQuotes: '/quote/your-saved-quotes',
        productQuote: '/quote/your-product-quote'
    }

};